import { WORKSPACE_URI } from '../constants/envConfig';
const icons = {};
// 从16开始，是改版ui的新的cover图。
for (let i = 1; i <= 25; i++) {
    icons[i] = `${WORKSPACE_URI}/a-workspace/permanent/space-covers/${i}.png`;
}
export { icons, };
